import { Dispatch, SetStateAction, createContext } from 'react';
import { SessionType } from 'models/Message';
import utils from 'utils';
import { XOR } from 'types';
import { QAndASides } from 'router/subrouters/DataRoom/models/QAndA';

export type MessagingPortfolioProps = {
  listingId: string;
} & XOR<{ dealRoomId: string }, { listingEnquiryId: string }>;

type MessagingContextProps = {
  contactOpen: boolean;
  contactsOpen: boolean;
  sessionId: string;
  loadingSession: boolean;
  currentSession: SessionType;
  messagingPortfolioProps?: MessagingPortfolioProps;
  userSide: QAndASides;
  setContactsOpen: Dispatch<SetStateAction<boolean>>;
  setContactOpen: Dispatch<SetStateAction<boolean>>;
  updateCurrentSession: (updatedSession: Partial<SessionType>) => void;
};

export default createContext<MessagingContextProps>({
  contactOpen: true,
  contactsOpen: true,
  sessionId: null,
  loadingSession: false,
  currentSession: null,
  messagingPortfolioProps: null,
  userSide: null,
  setContactOpen: utils.noop,
  setContactsOpen: utils.noop,
  updateCurrentSession: utils.noop,
});
